import _ from 'underscore';
import ko from 'knockout';

export default class ViewModel {
  constructor() {
    this.isValid = ko.observable(true);

    this.handleErrors = (errors) => {
      this.isValid(!_.isEmpty(errors));
    };
  }
}
